import type { Contact } from '@/src/utils/types';

export interface ApplicationConfigurationEntry {
  property_name?: string;
  property_value?: string | number | boolean | null;
}

export const APPLICATION_CONFIGURATION_ENDPOINT = 'http://evo-api:8000/api/evo/bioapi/v2/applicationConfiguration/';
export const APPLICATION_CONFIGURATION_CLIENT_ENDPOINT = '/api/evo/bioapi/v2/applicationConfiguration/';
export const MAINTENANCE_MODE_POLL_INTERVAL_MS = 60000;
const MAINTENANCE_MODE_PROPERTIES = new Set(['maintenance_enabled', 'maintenance_mode']);
const TRUTHY_MAINTENANCE_VALUES = new Set(['1', 'TRUE', 'True', 'true']);

export const getApplicationConfiguration = async (): Promise<ApplicationConfigurationEntry[]> => {
  const response = await fetch(APPLICATION_CONFIGURATION_CLIENT_ENDPOINT, {
    credentials: 'same-origin',
  });

  if (!response.ok) {
    return [];
  }

  const json = await response.json();
  return Array.isArray(json) ? (json as ApplicationConfigurationEntry[]) : [];
};

export const getApplicationConfigurationServer = async (
  cookieHeader?: string
): Promise<ApplicationConfigurationEntry[]> => {
  try {
    const response = await fetch(APPLICATION_CONFIGURATION_ENDPOINT, {
      headers: cookieHeader ? { Cookie: cookieHeader } : undefined,
    });

    if (!response.ok) {
      return [];
    }

    const json = await response.json();
    return Array.isArray(json) ? (json as ApplicationConfigurationEntry[]) : [];
  } catch {
    return [];
  }
};

export const isMaintenanceModeEnabled = (configuration: ApplicationConfigurationEntry[] = []): boolean => {
  return configuration.some((entry) => {
    if (!entry?.property_name || !MAINTENANCE_MODE_PROPERTIES.has(entry.property_name)) {
      return false;
    }

    if (entry.property_value === true || entry.property_value === 1) {
      return true;
    }

    if (typeof entry.property_value === 'string') {
      return TRUTHY_MAINTENANCE_VALUES.has(entry.property_value.trim());
    }

    return false;
  });
};

export const isMaintenanceModeBypassedForUser = (user?: Contact | null): boolean => {
  return user?.contact_type === 'admin';
};
